/**
 * NOTE: This service refers to the <Flag> Atlaskit component and managing how content types trigger
 * it. It does NOT refer to feature flags
 * See: https://atlassian.design/components/flag/examples
 */
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

import { getContentTypesFlagIcon } from '../utils/get-content-types-flag-icon.tsx';

import type { ContentTypesFlagProps } from './content-types-flag-service-types.ts';

export class ContentTypesFlagService {
	#flags: FlagsStateContainer;

	constructor(flags: FlagsStateContainer) {
		this.#flags = flags;
	}

	showFlag(flagProps: ContentTypesFlagProps): void {
		void this.#flags.showFlag({
			...flagProps,
			customIcon:
				flagProps.type === 'custom'
					? getContentTypesFlagIcon(
							flagProps.iconString,
							flagProps.iconColor,
							flagProps.profilePicture,
						)
					: undefined,
		});
	}

	hideFlag(flagId: string): void {
		void this.#flags.hideFlag(flagId);
	}
}
